export const SWITCH_BUTTON = {
  CONTAINER: 'switch-button-container',
  INPUT: 'switch-button-input',
  SLIDER: 'switch-button-slider'
} as const;
